
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("225Fx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e6c94e1a5809064$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $7e6c94e1a5809064$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "\xc9quipe \u2022\xa0Plus de 50\xa0membres",
    'fabric.elements.mentions.team.member.50plus.including.you': "\xc9quipe \u2022\xa0Plus de 50\xa0membres, dont vous",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {\xc9quipe \u2022\xa01\xa0membre} other {\xc9quipe \u2022\xa0{0}\xa0membres}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {\xc9quipe \u2022\xa01\xa0membre, dont vous} other {\xc9quipe \u2022\xa0{0}\xa0membres, dont vous}}",
    'fabric.elements.mentions.xproduct.mention.description': "A besoin d'un acc\xe8s \xe0 Confluence",
    'fabric.mention.error.defaultAction': "R\xe9essayez dans quelques secondes",
    'fabric.mention.error.defaultHeadline': "Une erreur s'est produite",
    'fabric.mention.error.differentText': 'Essayer de modifier le texte',
    'fabric.mention.error.loginAgain': "Essayez de vous d\xe9connecter et de vous reconnecter",
    'fabric.mention.noAccess.label': "Aucun acc\xe8s",
    'fabric.mention.noAccess.warning': "{name} ne sera pas pr\xe9venu, car cet utilisateur n'a pas d'acc\xe8s",
    'fabric.mention.unknow.user.error': 'Utilisateur inconnu {userId}'
};

});


//# sourceMappingURL=fr.498beda1.js.map
